import * as yup from "yup";

import i18n from "@/i18n";

export const driverLicenseAndIdFormValidation = (birthdate: Date): yup.AnyObjectSchema => {
    let validFromValidation = yup.date().presentOrPast();
    let issueDateValidation = yup.date().presentOrPast();
    if (birthdate) {
        validFromValidation = validFromValidation.min(birthdate, i18n.t("Validations.DateBeforeBirthDate"));
        issueDateValidation = issueDateValidation
            .minXYearsOld(16, birthdate)
            .min(birthdate, i18n.t("Validations.DateBeforeBirthDate"));
    }
    return yup.object({
        "identityCard-nationalNumber": yup.string().exactLength(11),
        "identityCard-validTo": yup.date().onFuture().nullable(),
        "identityCard-validFrom": validFromValidation.nullable(),
        "driversLicense-issueDate": issueDateValidation.nullable(),
    });
};
